"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var axios_1 = __importDefault(require("axios"));
var client_1 = require("react-dom/client");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var stripe_js_1 = require("@stripe/stripe-js");
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var styles_1 = require("@mui/material/styles");
var Lang_js_1 = require("../Lang.js");
var MsiaTheme_jsx_1 = __importDefault(require("../MsiaTheme.jsx"));
var CheckoutForm_1 = __importDefault(require("./CheckoutForm"));
var SavedPaymentMethods_1 = __importDefault(require("./SavedPaymentMethods"));
var IntentURL_1 = __importDefault(require("./IntentURL"));
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var Stepper_1 = __importDefault(require("../Generic/Stepper"));
var Telemetry_jsx_1 = __importDefault(require("../Generic/Telemetry.jsx"));
var LastTransactionContext_1 = require("./LastTransactionContext");
var form = document.getElementById('donation-form');
/**
 * Returns the HTTP status code from an axios error, or null if the request
 * failed without a response (network error, timeout, etc.).
 */
function httpStatus(error) {
    var _a, _b;
    return axios_1.default.isAxiosError(error) ? ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : null) : null;
}
function handleCaptcha(value) {
    var _a, _b;
    var sitekey = form.getAttribute('captcha_sitekey');
    var stripePromise = (0, stripe_js_1.loadStripe)((_a = form.getAttribute('pk')) !== null && _a !== void 0 ? _a : "");
    var amount = parseInt((_b = form.getAttribute('amount')) !== null && _b !== void 0 ? _b : "1.00");
    var root = (0, client_1.createRoot)(form);
    axios_1.default.get((0, IntentURL_1.default)(amount) + '&captchaValue=' + value)
        .then(function (response) {
        var status = response.data.status;
        if (status == 'success') {
            var clientSecret = response.data.client_secret;
            var customerId = response.data.customer_id;
            root.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                    react_1.default.createElement(LastTransactionContext_1.LastTransactionProvider, null,
                        react_1.default.createElement(Donate, { stripePromise: stripePromise, amount: amount, clientSecret: clientSecret, customerId: customerId, loggedIn: false })))));
        }
        else if (status == 'captcha') {
            root.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                    react_1.default.createElement(react_google_recaptcha_1.default, { id: "captcha", sitekey: sitekey, onChange: handleCaptcha }),
                    react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Captcha required')))));
        }
        else {
            // invalid status response
            console.warn(response.data);
            root.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                    react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
                    react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: response.data }))));
        }
    })
        .catch(function (error) {
        // error retrieving client secret from server for payment intent
        console.warn(error);
        root.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
                react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: error }))));
    });
}
/**
 * The logged-in donation shell: optional seedcard stepper, the amount heading,
 * an optional saved-payment-methods picker, and the Donate form — all wrapped in
 * a single LastTransactionProvider. Used for both the saved-cards-loaded path and
 * the fallback path where loading saved cards failed, so the markup lives once.
 */
var DonateFlow = function (props) { return (react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
    props.isSeedcard &&
        react_1.default.createElement("div", null,
            react_1.default.createElement(Stepper_1.default, { steps: [(0, Lang_js_1.__)('Choose a Card'), (0, Lang_js_1.__)('Enter Delivery Details'), (0, Lang_js_1.__)('Place Your Seed')], activeStep: 2, mb: 4 }),
            react_1.default.createElement(material_1.Typography, { variant: "h6", component: "h3", m: 4 },
                "3. ",
                (0, Lang_js_1.__)('Place Your Seed'))),
    react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(material_1.Typography, { variant: "h5", sx: { mb: 2 } },
            (0, Lang_js_1.__)(props.imperativeVerb),
            " $",
            (props.amount / 100).toLocaleString('us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })),
        react_1.default.createElement(LastTransactionContext_1.LastTransactionProvider, null,
            props.savedPaymentMethods &&
                react_1.default.createElement(SavedPaymentMethods_1.default, { payment_methods: props.savedPaymentMethods }),
            react_1.default.createElement(Donate, { stripePromise: props.stripePromise, amount: props.amount, clientSecret: props.clientSecret, customerId: props.customerId, loggedIn: true }))))); };
var Donate = function (props) {
    if (props.clientSecret == null) {
        // no client secret
        console.warn("Empty client secret");
        return (react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
            react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
            react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: "Empty client secret" })));
    }
    else {
        var stripeLocale = Lang_js_1.lang === 'es' ? 'es' : 'auto';
        var stripeOptions = {
            locale: stripeLocale,
            clientSecret: props.clientSecret,
        };
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(react_stripe_js_1.Elements, { stripe: props.stripePromise, options: stripeOptions },
                react_1.default.createElement(LastTransactionContext_1.LastTransactionProvider, null,
                    react_1.default.createElement(CheckoutForm_1.default, { stripePromise: props.stripePromise, clientSecret: props.clientSecret, customerId: props.customerId, loggedIn: props.loggedIn })))));
    }
};
if (form) {
    var isSeedcard_1 = form.getAttribute('is_seedcard') == 'true';
    var sitekey_1 = form.getAttribute('captcha_sitekey');
    var stripePromise_1 = (0, stripe_js_1.loadStripe)((_a = form.getAttribute('pk')) !== null && _a !== void 0 ? _a : "");
    var amount_1 = parseInt((_b = form.getAttribute('amount')) !== null && _b !== void 0 ? _b : "1.00");
    var imperative_verb_1 = form.getAttribute('imperative_verb').includes('[imperative verb]') ? "Give" : (_c = form.getAttribute('imperative_verb')) !== null && _c !== void 0 ? _c : "Give";
    var root_1 = (0, client_1.createRoot)(form);
    // Renders the guest (not-logged-in) donation flow: fetches a payment intent
    // without a saved customer, then shows the "Log in to save your payment
    // methods" prompt above the new-card donation form. Used both when the
    // status check returns HTTP 401 (not logged in) and when it fails for any
    // other reason, so guests can always still donate.
    var renderGuestFlow_1 = function () {
        axios_1.default.get((0, IntentURL_1.default)(amount_1))
            .then(function (response) {
            var status = response.data.status;
            if (status == 'success') {
                var clientSecret = response.data.client_secret;
                var customerId = response.data.customer_id;
                root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                        react_1.default.createElement(material_1.Typography, { variant: "h5", sx: { mb: 2 } },
                            (0, Lang_js_1.__)(imperative_verb_1),
                            " $",
                            (amount_1 / 100).toLocaleString('us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })),
                        react_1.default.createElement(material_1.Card, { sx: { mb: 4 } },
                            react_1.default.createElement(material_1.CardContent, null,
                                react_1.default.createElement(material_1.Typography, null,
                                    react_1.default.createElement(icons_material_1.Notifications, { color: "primary" }),
                                    " ",
                                    (0, Lang_js_1.__)("Log in to securely save and re-use your payment methods next time"))),
                            react_1.default.createElement(material_1.CardActions, null,
                                react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", sx: { p: 1, mt: 1, mb: 1, maxWidth: 480 }, onClick: function () { window.location.href = "/app/students/login?previous_url=" + encodeURIComponent(window.location.pathname + window.location.search) + "&lang=" + Lang_js_1.lang; } }, (0, Lang_js_1.__)("Log In")))),
                        react_1.default.createElement(material_1.Typography, { align: "center", variant: "h5", sx: { mb: 2, mt: 2 } }, (0, Lang_js_1.__)('or enter new payment details below')),
                        react_1.default.createElement(LastTransactionContext_1.LastTransactionProvider, null,
                            react_1.default.createElement(Donate, { stripePromise: stripePromise_1, amount: amount_1, clientSecret: clientSecret, customerId: customerId, loggedIn: false })))));
            }
            else if (status == 'captcha') {
                // display captcha
                root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                        react_1.default.createElement(react_google_recaptcha_1.default, { id: "captcha", sitekey: sitekey_1, onChange: handleCaptcha }),
                        react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Captcha required')))));
            }
            else {
                // error retrieving client secret
                console.warn("Unable to retrieve client secret");
                root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                        react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
                        react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: "Unable to retrieve client secret" }))));
            }
        })
            .catch(function (error) {
            // error retrieving client secret from server for payment intent for NOT-logged-in-user
            console.warn(error);
            root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                    react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
                    react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: error }))));
        });
    };
    axios_1.default.get('/api/v2/students/status')
        .then(function (response) {
        if (typeof response.data.user === "object") {
            // user logged in
            axios_1.default.get((0, IntentURL_1.default)(amount_1, true))
                .then(function (response) {
                var clientSecret = response.data.client_secret;
                var customerId = response.data.customer_id;
                axios_1.default.get('/api/donations/getSavedPaymentMethods')
                    .then(function (response) {
                    root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                        react_1.default.createElement(DonateFlow, { stripePromise: stripePromise_1, clientSecret: clientSecret, customerId: customerId, amount: amount_1, imperativeVerb: imperative_verb_1, isSeedcard: isSeedcard_1, savedPaymentMethods: response.data.payment_methods })));
                })
                    .catch(function (_error) {
                    root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                        react_1.default.createElement(DonateFlow, { stripePromise: stripePromise_1, clientSecret: clientSecret, customerId: customerId, amount: amount_1, imperativeVerb: imperative_verb_1, isSeedcard: isSeedcard_1 })));
                });
            })
                .catch(function (error) {
                // error retrieving client secret from server for payment intent for logged-in-user
                console.warn(error);
                root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
                        react_1.default.createElement(material_1.Alert, { severity: "error" }, (0, Lang_js_1.__)('Unable to process payments at this time')),
                        react_1.default.createElement(Telemetry_jsx_1.default, { originator: "stripe", message: error }))));
            });
        }
        else {
            // HTTP 2xx but no user object in the payload: treat as not logged in
            // and fall through to the guest donation flow.
            renderGuestFlow_1();
        }
    })
        .catch(function (error) {
        var status = httpStatus(error);
        if (status === 401) {
            // not logged in (expired/absent session) -> guest donation flow
            renderGuestFlow_1();
        }
        else {
            // Any other HTTP error or a network failure on the status check.
            // We can't confirm the user, so fall back to the guest flow so a
            // donation can still be made rather than blocking the page.
            console.warn(error);
            renderGuestFlow_1();
        }
    });
    root_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: MsiaTheme_jsx_1.default },
            react_1.default.createElement(material_1.Modal, { open: true, onClose: function () { return; }, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
                react_1.default.createElement(material_1.Box, { display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", bgcolor: "white" },
                    react_1.default.createElement("div", { id: "modal-modal-title", style: { display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement(material_1.CircularProgress, null)),
                    react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'center', minHeight: '3rem', marginLeft: '1rem' } },
                        react_1.default.createElement(material_1.Typography, { id: "modal-modal-description", sx: { mt: 2 } }, (0, Lang_js_1.__)("Establishing secure connection..."))))))));
}
exports.default = Donate;
